import { render } from "./RatingPicker.vue?vue&type=template&id=242b27a5"
import script from "./RatingPicker.vue?vue&type=script&lang=js"
export * from "./RatingPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__